import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Privary from '@/components/Privary'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/Privary',
      name: 'Privary',
      component: Privary
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js